export const createSettingsCookie = (gid: string, timestamp: string) =>
  btoa(JSON.stringify({gid, timestamp}));

export const parseSettingsCookie = (cookie?: string) => {
  if (!cookie) {
    return null;
  }

  try {
    return JSON.parse(atob(cookie)) as {gid: string; timestamp: string};
  } catch (e) {
    return null;
  }
};
